module.exports = __webpack_public_path__ + "img/IMG20190716185900.4f22dcb4.jpg";